import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { btlApplicationFormApi } from '../../../api/btlApplicationForm';
import { MissingCaseFields } from 'pages/BtlApplicationFormPage/types';
import { HouseholdsToHasIndividuals } from 'api/btlApplicationForm/types';

export const useBtlMissingFields = (
  applicationId: string,
): UseQueryResult<
  | { householdsToHasIndividuals: HouseholdsToHasIndividuals; isComplete: boolean; missingFields: MissingCaseFields }
  | undefined
> =>
  useQuery(['btl-missing-fields', applicationId], () =>
    applicationId ? btlApplicationFormApi.getMissingFields(applicationId) : null,
  );
